exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2L6hNyMQu4wDVyHgEP704c{width:400px}html[dir] ._2L6hNyMQu4wDVyHgEP704c{-webkit-box-shadow:none;box-shadow:none;border:none}._1WCj0OnzHS7e1bcehkID2w{color:\"[theme:white, default:#ffffff]\"}html[dir] ._1WCj0OnzHS7e1bcehkID2w{background-color:\"[theme:themePrimary, default:#0078D7]\";padding:15px 20px 20px}._1mYHrOmUWFz44it0ls0R-i{font-size:28px;font-weight:100}html[dir] ._1mYHrOmUWFz44it0ls0R-i{margin:0}._3eKkP074V46awKfplNtQat{font-size:14px;font-weight:400}.uyvv4cOiKuhDHldjNynan{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] .uyvv4cOiKuhDHldjNynan{border:1px solid \"[theme:white, default:#ffffff]\";background-color:\"[theme:white, default:#ffffff]\"}.uyvv4cOiKuhDHldjNynan:hover{color:\"[theme:white, default:#ffffff]\"}html[dir] .uyvv4cOiKuhDHldjNynan:hover{background-color:\"[theme:themePrimary, default:#0078D7]\"}", ""]);

// exports
exports.locals = {
	"callout": "_2L6hNyMQu4wDVyHgEP704c",
	"container": "_1WCj0OnzHS7e1bcehkID2w",
	"title": "_1mYHrOmUWFz44it0ls0R-i",
	"content": "_3eKkP074V46awKfplNtQat",
	"button": "uyvv4cOiKuhDHldjNynan"
};